import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const AdminLogin = lazy(() => import('src/pages/admin/AdminLogin'));
const AdminHome = lazy(() => import('src/pages/admin/AdminHome'));

/**
 * Routes for the admin pages.
 * They have to be nested under the `/admin` route.
 */
export const adminRoutes = [
    <Route key="login" path="login" element={<AdminLogin />} />,

    // requires auth
    <Route key="home" path="home" element={<AdminHome />} />,
];